"use strict";

import angular from "angular";

const name = "activeLink";
const factory = [
    "$state",
    "$transitions",
    "$location",
    ($state, $transitions, $location) => {
        return {
            restrict: "A",
            link: (scope, element, attrs, controller) => {
                if (attrs.activeLinkSref) {
                    const sref = JSON.parse(attrs.activeLinkSref);
                    const activeClass = attrs.activeLink;
                    if (sref === $state.current.name)
                        element.addClass(activeClass);
                    else element.removeClass(activeClass);
                    scope.$watch(
                        () => $location.$$path || $state.current.name,
                        (newState) => {
                            const dontActive = attrs.dontActive
                                ? JSON.parse(attrs.dontActive)
                                : false;
                            if (
                                sref.findIndex(
                                    (s) => s === $state.current.name
                                ) > -1 &&
                                !dontActive
                            )
                                element.addClass(activeClass);
                            else element.removeClass(activeClass);
                        }
                    );
                }
            }
        };
    }
];
angular.module("nucont.shared").directive(name, factory);
export default { name, factory };
